<i aria-hidden="true"
   class="col-1"
   [ngClass]="side === 'left' ? 'icon-chevron2-left' : 'icon-chevron2-right'"></i>